import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { PollResponseHandler } from "abweb/service/rpc/PollResponseHandler";
import { RPCPollingService } from "abweb/service/rpc/RPCPollingService";
import { ASYNC_QUEUE_VIEW_FULL, ASYNC_QUEUE_VIEW_UPDATE } from "abweb/service/rpc/StreamingRPCService";
import { TaskPoller } from "abweb/service/rpc/TaskPoller";
import { ViewSubscription } from "abweb/service/rpc/ViewSubscription";
import { Assert } from "abweb/utils/Assert";
import { computed, makeObservable, observable } from "mobx";
export let StreamingRPCServiceImpl = (_class = class StreamingRPCServiceImpl {
  constructor() {
    /**
     *  taskPoller is initialized at some point during application startup.
     *  Until then, need to be careful of using it.
     *  External callers can watch for taskPollerId changes (mobx-backed) that happen
     *  when a new TaskPoller is created after a lost session workflow.
     */
    _initializerDefineProperty(this, "taskPoller", _descriptor, this);
    makeObservable(this);
  }
  getIsReady() {
    return this.taskPoller != null && !this.taskPoller.canceled;
  }

  /** @return current task poller id (int > 0), and 0 when there is no task poller  */
  get taskPollerId() {
    return this.taskPoller?.taskPollerId ?? 0;
  }
  lazyCreateTaskPoller(rpcService, idleTimeout, sessionTimeout, isWSDisabled) {
    if (this.taskPoller) {
      this.taskPoller = this.taskPoller.reset();
    } else {
      this.taskPoller = new TaskPoller(new RPCPollingService(rpcService), idleTimeout, sessionTimeout, isWSDisabled);
    }
  }
  stopPolling() {
    if (this.taskPoller) {
      this.taskPoller.stopPolling();
    }
  }
  validTaskPoller() {
    Assert.assert(this.taskPoller != null, "Invoking a streaming rpc but taskPoller is not initialized.");
    return this.taskPoller;
  }

  /**
   * @inheritdoc
   */
  invokeAsyncVoid(appRelativeUrl, namedParams, messageHandlers, init) {
    return this.validTaskPoller().startPollingTaskVoid(appRelativeUrl, namedParams, new PollResponseHandler(null, messageHandlers), init);
  }

  /**
   * @inheritdoc
   */
  invokeAsync(appRelativeUrl, namedParams, pollResponseParser, messageHandlers, init) {
    return this.validTaskPoller().startPollingTask(appRelativeUrl, namedParams, new PollResponseHandler(pollResponseParser, messageHandlers), init);
  }

  /**
   * @inheritdoc
   */
  invokeView(appRelativeUrl, namedParams, fullViewHandler, updateViewHandler, init) {
    const messageHandlers = {};
    messageHandlers[ASYNC_QUEUE_VIEW_FULL] = fullViewHandler;
    messageHandlers[ASYNC_QUEUE_VIEW_UPDATE] = updateViewHandler;
    return new ViewSubscription(this.validTaskPoller().startPollingTask(appRelativeUrl, namedParams, new PollResponseHandler(fullViewHandler, messageHandlers, true), init));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "taskPoller", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _applyDecoratedDescriptor(_class.prototype, "taskPollerId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "taskPollerId"), _class.prototype), _class);
//# sourceMappingURL=StreamingRPCServiceImpl.js.map
